import { Navigate } from "react-router-dom";

import BarrierCameraPage from "./pages/camera";
import BarrierCameraViewPage from "./pages/view-camera";
import BarrierCarPage from "./pages/car-manage";
import BarrierDashboardPage from "./pages/dashboard";
import BarrierGatePage from "./pages/gate";
import BarrierHumanLogPage from "./pages/human-log";
import BarrierLogPage from "./pages/log";
import BarrierMotoLogPage from "./pages/moto-log";

const BarrierRoutes = [
  { path: "logs", element: <BarrierLogPage /> },
  { path: "human-logs", element: <BarrierHumanLogPage /> },
  { path: "moto-logs", element: <BarrierMotoLogPage /> },
  { path: "barrier-cameras", element: <BarrierCameraPage /> },
  { path: "barrier-gate", element: <BarrierGatePage /> },
  { path: "dashboard", element: <BarrierDashboardPage /> },
  { path: "car-manage", element: <BarrierCarPage /> },
  { path: "camera-view", element: <BarrierCameraViewPage /> },

  { path: "*", element: <Navigate to="/barrier/logs" /> }
];

export default BarrierRoutes;
